import styled from 'styled-components'
import { Icon } from 'antd'

export const IconArrow = styled(Icon)`
  color: ${(props) => props.theme.testItemPreview.iconArrowColor};
`
